import { AppComponent } from './../app.component';
import { ProcesosGlobalesService } from './../Servicios/procesos-globales.service';
import { CredencialesEmpresa } from './../Modelos/CredencialesEmpresa';
import { globalConf } from 'src/app/Modelos/GlobalConf';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, NgZone } from '@angular/core';
import { VariablesService } from '../Servicios/variables.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiciosService } from '../Servicios/servicios.service';
import { triggerAsyncId } from 'async_hooks';



@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage implements OnInit {

  constructor(
    public variables: VariablesService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public http: HttpClient,
    public servicio: ServiciosService,
    public ngZone: NgZone,
    public procesosGlobales: ProcesosGlobalesService,
    public appComponent: AppComponent
  ) {
    // OBTIENE LOS PARAMETROS EN LA URL
    this.activatedRoute.queryParams
      .subscribe(async params => {
        console.log("parámetros ", params);

        let idCredencial = params.Credencial;
        // SI ENCUENTRA DATOS EN LA URL CON ESE ID HACE LA PETICION A FIREBASE FUNCTIONS
        if (idCredencial) {

          await this.servicio.presentLoading('Conectando ...');

          await this.http.get(globalConf.path_firebaseFunctions + globalConf.path_path_firebaseFunctions_credenciales + "/" + idCredencial).toPromise()
            .then(async (datosCredencial) => {

              // SE PONEN LAS VARIABLES POR DEFECTO
              this.variables.metodoAcceso = "CredencialALO";
              this.variables.empresasUsuario = [];
              this.variables.empresaSeleccionada = null;
              this.variables.pwd = "";
              this.variables.usuario = "";
              this.variables.tokenLogin = null;
              this.variables.recordarUsuario = false;
              this.variables.credencialRetoValida = null;
              this.variables.loginCorrecto = false;
              // ----------------------------------------------

              // CUANDO SE OBTIENE EL RESULTADO DE LA PETICION NAVEGA A TAB2
              console.log("Datos de las credenciales: ", datosCredencial);
              this.variables.credencialesEmpresa = datosCredencial as CredencialesEmpresa;

              // ASIGNACIONES DE LA EMPRESA SELECCIONADA CON LOS DATOS DEL ENLACE ALO
              console.log("Lo que hay ahora mismo en variables? ", this.variables.empresaSeleccionada);


              this.variables.empresaSeleccionada = {
                GUID_Empresa: this.variables.credencialesEmpresa.GUID_Empresa,
                Id: Number.parseInt(this.variables.credencialesEmpresa.Id_Empresa),
                Nombre: this.variables.credencialesEmpresa.NombreEmpresa,

                ModulosActivos: [],
                NIF: "",
                Pais: "",
                Poblacion: "",
                Provincia: "",
                RazonSocial: "",
                Web: ""
              }


              console.log("Datos de empresa por enlace actualizados", this.variables.credencialesEmpresa, this.variables.empresaSeleccionada);

              let keyDesencriptarAES = this.variables.credencialesEmpresa.GUID_Empresa.substr(9, 16);
              console.log("Clave desencriptacion: ", keyDesencriptarAES);

              if (this.variables.credencialesEmpresa.UsuarioReto) this.variables.credencialesEmpresa.UsuarioReto = this.servicio.desencriptarAES(this.variables.credencialesEmpresa.UsuarioReto, keyDesencriptarAES);
              else this.variables.credencialesEmpresa.UsuarioReto = "";

              if (this.variables.credencialesEmpresa.PasswordReto) this.variables.credencialesEmpresa.PasswordReto = this.servicio.desencriptarAES(this.variables.credencialesEmpresa.PasswordReto, keyDesencriptarAES);
              else this.variables.credencialesEmpresa.PasswordReto = "";


              this.variables.credencialesRETO.UsuarioReto = this.variables.credencialesEmpresa.UsuarioReto;
              this.variables.credencialesRETO.ContraseñaReto = this.variables.credencialesEmpresa.PasswordReto;
              /* this.variables.pwd = this.variables.credencialesEmpresa.UsuarioReto;
              this.variables.usuario = this.variables.credencialesEmpresa.PasswordReto; */

              console.log("Credenciales finales desencriptadas: ", this.variables.credencialesEmpresa);
              console.log("Empresa seleccionada: ", this.variables.empresaSeleccionada);

              this.variables.metodoAcceso = "Empresa"
              this.variables.loginCorrecto = true;
              //await this.cargarAlmacenes()

              await this.servicio.dissmisLoading()
              this.router.navigate(['tabs/tab2'])

            })
            .catch(async (error) => {
              await this.servicio.dissmisLoading()
              console.error("Error al obtener datos firebase functions", error);
            })
        } else {
          //await this.cargarAlmacenes()
          this.servicio.dissmisLoading()
          console.log("sin credencial en URL , login ALO", this.variables.empresaSeleccionada)
          this.router.navigate(['tabs/tab2']);
        }
      }
      );
  }

  ngOnInit(): void {

  }
  
  logOff(){
    this.appComponent.logOff()
  }

}
